module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "topicManage"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("话题管理")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('el-form', {
    staticClass: "search-row",
    attrs: {
      "inline": true,
      "model": _vm.queryParam,
      "label-width": "72px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "话题ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "精确搜索",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.clickSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryParam.topicId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "topicId", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "queryParam.topicId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "模糊搜索",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.clickSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryParam.createdUid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "createdUid", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "queryParam.createdUid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "话题名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "模糊搜索",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.clickSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryParam.topicName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "topicName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "queryParam.topicName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "话题类别"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.queryParam.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "categoryId", $$v)
      },
      expression: "queryParam.categoryId"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.categories), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "创建时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "时间选择器"
    },
    model: {
      value: (_vm.queryParam.beginCreatedAtMs),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "beginCreatedAtMs", $$v)
      },
      expression: "queryParam.beginCreatedAtMs"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "range-divider"
  }, [_vm._v("~")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "时间段"
    },
    model: {
      value: (_vm.queryParam.endCreatedAtMs),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endCreatedAtMs", $$v)
      },
      expression: "queryParam.endCreatedAtMs"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否精选"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.queryParam.isEssence),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isEssence", $$v)
      },
      expression: "queryParam.isEssence"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "是",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": 0
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否置顶"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.queryParam.isSticky),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isSticky", $$v)
      },
      expression: "queryParam.isSticky"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "是",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": 0
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已发布",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已停用",
      "value": 1
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "search-action-item"
  }, [_c('el-button', {
    on: {
      "click": _vm.clickReset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickSearch
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goNewTopic
    }
  }, [_vm._v("新建话题")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.createTopicForm.id > 0 ? '编辑话题' : '新增话题',
      "custom-class": "topic-create-drawer",
      "top": "0",
      "modal-append-to-body": false,
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.handleCreateDialogClose
    },
    model: {
      value: (_vm.createTopicDialogVisible),
      callback: function($$v) {
        _vm.createTopicDialogVisible = $$v
      },
      expression: "createTopicDialogVisible"
    }
  }, [_c('div', {
    staticClass: "topic-create-content"
  }, [_c('el-form', {
    ref: "createTopicForm",
    attrs: {
      "model": _vm.createTopicForm,
      "rules": _vm.createTopicRules,
      "label-width": "92px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "话题头像",
      "prop": "coverImage"
    }
  }, [_c('SUpload', {
    attrs: {
      "value": [_vm.createTopicForm.coverImage],
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "show-file-list": false,
      "on-success": _vm.handleCoverUploadSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "supload-tips"
  }, [_vm._v("\n            建议尺寸73*73，大小≤50KB，优先webp次选png\n          ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详情页图片",
      "prop": "detailImage"
    }
  }, [_c('SUpload', {
    attrs: {
      "value": [_vm.createTopicForm.detailImage],
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "show-file-list": false,
      "on-success": _vm.handleDetailUploadSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "supload-tips"
  }, [_vm._v("\n            建议尺寸375*184，大小≤50KB，优先webp次选png\n          ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "话题名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "50",
      "placeholder": "话题名称",
      "disabled": _vm.createTopicForm.id > 0
    },
    model: {
      value: (_vm.createTopicForm.title),
      callback: function($$v) {
        _vm.$set(_vm.createTopicForm, "title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "createTopicForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "摘要",
      "prop": "summary"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "maxlength": 500,
      "placeholder": "不超过500个字符"
    },
    model: {
      value: (_vm.createTopicForm.summary),
      callback: function($$v) {
        _vm.$set(_vm.createTopicForm, "summary", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "createTopicForm.summary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类别",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.createTopicForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.createTopicForm, "categoryId", $$v)
      },
      expression: "createTopicForm.categoryId"
    }
  }, _vm._l((_vm.categories), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('select-school', {
    attrs: {
      "schObj": _vm.createTopicForm.schObj
    },
    on: {
      "changeVal": _vm.handleSchoolChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "topic-create-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.createTopicDialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitCreateTopic
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.listData,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "话题ID",
      "min-width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "封面图片",
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.coverImage) ? _c('img', {
          staticClass: "thumb-img thumb-img-clickable",
          attrs: {
            "src": row.coverImage,
            "alt": ""
          },
          on: {
            "click": function($event) {
              return _vm.openImagePreview(row.coverImage, '话题图片')
            }
          }
        }) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "详情页图片",
      "min-width": "140",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.detailImage) ? _c('img', {
          staticClass: "thumb-img thumb-img-clickable",
          attrs: {
            "src": row.detailImage,
            "alt": ""
          },
          on: {
            "click": function($event) {
              return _vm.openImagePreview(row.detailImage, '详情页图片')
            }
          }
        }) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "话题名称",
      "min-width": "180",
      "align": "center",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "category",
      "label": "类别",
      "min-width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTimeText",
      "label": "创建时间",
      "min-width": "170",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createrText",
      "label": "创建人",
      "min-width": "95",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "participateUserCount",
      "label": "发帖人数",
      "min-width": "140",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "postCount",
      "label": "发帖次数",
      "min-width": "140",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "detailViewCount",
      "label": "详情页浏览次数",
      "min-width": "165",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isEssenceText",
      "label": "是否精选",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否置顶",
      "min-width": "190",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.isSticky === 1) ? _c('div', {
          staticClass: "pin-time-cell"
        }, [_c('div', [_vm._v("是")]), _vm._v(" "), _c('div', {
          staticClass: "pin-time-line"
        }, [_vm._v("\n              " + _vm._s(row.stickyStartAtText || "--") + "\n            ")]), _vm._v(" "), (row.stickyEndAtText) ? _c('div', {
          staticClass: "pin-time-line"
        }, [_vm._v("\n              至 " + _vm._s(row.stickyEndAtText) + "\n            ")]) : _vm._e()]) : _c('span', [_vm._v("否")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusText",
      "label": "状态",
      "min-width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "280",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openEditTopic(row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.toggleRowStatus(row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(Number(row.status) === 2 ? "停用" : "启用") + "\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.toggleRowEssence(row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(Number(row.isEssence) === 1 ? "取消精选" : "精选") + "\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openPinDialog(row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(Number(row.isSticky) === 1 ? "取消置顶" : "置顶") + "\n          ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('div', {
    staticClass: "bottom-action-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedRows.length === 0
    },
    on: {
      "click": _vm.openBatchEssenceDialog
    }
  }, [_vm._v("精选")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedRows.length === 0
    },
    on: {
      "click": _vm.openBatchStatusDialog
    }
  }, [_vm._v("修改状态")])], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total > 0"
    }],
    staticClass: "topic-pagination",
    attrs: {
      "layout": "total, prev, pager, next, jumper",
      "page-size": _vm.queryParam.pageSize,
      "current-page": _vm.queryParam.pageNum,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "精选",
      "size": "tiny",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.batchEssenceDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.batchEssenceDialog, "visible", $$v)
      },
      expression: "batchEssenceDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否精选"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    model: {
      value: (_vm.batchEssenceDialog.isEssence),
      callback: function($$v) {
        _vm.$set(_vm.batchEssenceDialog, "isEssence", $$v)
      },
      expression: "batchEssenceDialog.isEssence"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "是",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": 0
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchEssenceDialog.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitBatchEssence
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改状态",
      "size": "tiny",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.batchStatusDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.batchStatusDialog, "visible", $$v)
      },
      expression: "batchStatusDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    model: {
      value: (_vm.batchStatusDialog.status),
      callback: function($$v) {
        _vm.$set(_vm.batchStatusDialog, "status", $$v)
      },
      expression: "batchStatusDialog.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "启用",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "停用",
      "value": 1
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchStatusDialog.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitBatchStatus
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "置顶",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.pinDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.pinDialog, "visible", $$v)
      },
      expression: "pinDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否置顶"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    model: {
      value: (_vm.pinDialog.isSticky),
      callback: function($$v) {
        _vm.$set(_vm.pinDialog, "isSticky", $$v)
      },
      expression: "pinDialog.isSticky"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "是",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": 0
    }
  })], 1)], 1), _vm._v(" "), (_vm.pinDialog.isSticky === 1) ? _c('el-form-item', {
    attrs: {
      "label": "置顶时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "380px"
    },
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "placeholder": "请选择开始时间至结束时间"
    },
    model: {
      value: (_vm.pinDialog.stickyTime),
      callback: function($$v) {
        _vm.$set(_vm.pinDialog, "stickyTime", $$v)
      },
      expression: "pinDialog.stickyTime"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-tip"
  }, [_vm._v("置顶后，该话题将在APP推荐页的第一个坑位")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pinDialog.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.pinSubmitting
    },
    on: {
      "click": _vm.submitPin
    }
  }, [_vm._v("确认")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.imagePreview.title,
      "size": "large",
      "modal-append-to-body": false,
      "custom-class": "topic-image-preview-dialog"
    },
    on: {
      "close": _vm.closeImagePreview
    },
    model: {
      value: (_vm.imagePreview.visible),
      callback: function($$v) {
        _vm.$set(_vm.imagePreview, "visible", $$v)
      },
      expression: "imagePreview.visible"
    }
  }, [_c('div', {
    staticClass: "image-preview-body"
  }, [(_vm.imagePreview.url) ? _c('img', {
    staticClass: "image-preview-img",
    attrs: {
      "src": _vm.imagePreview.url,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeImagePreview
    }
  }, [_vm._v("关闭")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d0935ff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/topic/topicManage.vue
// module id = 1040
// module chunks = 0